
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Group,
XButton,
Confirm
},
name: 'faceRecognition',
data() {
return {
card: {
cardHand: null,
cardHandBase64: ''
},
canvas: {},
show: false,
currentkey: '',
submitting: false,
}
},
created() {
this.currentkey = window.sessionStorage.getItem('currentkey');

},
methods: {
getImages(name, file) {
if (file != null) {
return this.getObjectURL(file)
} else if (name != undefined && name != null) {
return require(`@/assets/images/${name}.png`)
} else {
return require(`@/assets/images/default.png`)
}
},
getObjectURL(file) {
var url = null;
if (window.createObjectURL != undefined) { // basic
url = window.createObjectURL(file);
} else if (window.URL != undefined) { // mozilla(firefox)
url = window.URL.createObjectURL(file);
} else if (window.webkitURL != undefined) { // webkit or chrome
url = window.webkitURL.createObjectURL(file);
}
return url;
},
takePhoto(event) {

let imageFile = event.target.files[0];
this.card[event.target.name] = imageFile;
let that = this;
var img = new Image();
img.src = this.getObjectURL(imageFile);

img.onload = function () {
var originWidth = this.width; 
var originHeight = this.height;
var maxWidth = 400;
var quality = 1; 
var canvas = document.createElement('canvas');
var drawer = canvas.getContext("2d");
canvas.width = maxWidth;
canvas.height = originHeight / originWidth * maxWidth;
drawer.drawImage(img, 0, 0, canvas.width, canvas.height);

var base64 = canvas.toDataURL("image/jpeg", quality); 
that.card[event.target.name + 'Base64'] = base64;

var str = base64.replace('data:image/jpeg;base64,', '');
var strLength = str.length;
var fileLength = parseInt(strLength - (strLength / 8) * 2);

var size = "";
size = (fileLength / 1024).toFixed(2);
console.log('字节长度：' + parseInt(size));

};
},


convertImgToBase64(imageFile, callback, errorCallback) {
try {
let reader = new FileReader()
reader.readAsDataURL(imageFile)
reader.onload = function (e) {
if (callback) {
let base64Str = e.target.result
callback(base64Str)
}
}
} catch (error) {
console.error(error)
if (errorCallback) {
errorCallback(error)
}
}
},

submitFacePhoto() {
if (this.card['cardHandBase64'] == '' || this.card['cardHandBase64'] == undefined) {

this.$vux.confirm.show({content: '请进行人脸识别', showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
} else {
const projectId = this.$route.query.projectId;
const taskType = this.$route.query.taskType;








const thiss = this;
this.submitting = true;
this.$axios({
method: 'post',
url: '/wechat/faceValid.do',
data: {

openId: window.sessionStorage.getItem('openId'),
projectId: projectId,
imgData: this.card['cardHandBase64'],
taskType: taskType,

}
}).then((response) => {
if (response.data.code === 200) {
const projectId = this.$route.query.projectId;
const openId = window.sessionStorage.getItem("openId");
const noticeUrl = "/wechat/supplementaryNotice";
this.$axios({
method: 'post',
url: noticeUrl,
data: {
projectId: projectId,
openId: openId,
}
})
if (taskType === '1') {
thiss.sign();
} else {
thiss.show = true;
}
} else {
this.submitting = false;

this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
}).catch(() => {
this.submitting = false;
})
}





















},
onCancel() {

this.onConfirm();
},
onConfirm() {
if (this.currentkey == '2') {
const $this = this;
$this.$router.push({
path: '/productDetail',
query: {
projectId: $this.$route.query.projectId,
productCode: $this.$route.query.productCode,
productId: $this.$route.query.productId
}
})
} else if (this.currentkey == '1') {
this.$router.push({
path: '/waitTask',
});
} else {
WeixinJSBridge.call('closeWindow');
}

},

sign() {


const url = "wechat/completeOnlineSign.do";
const thiss = this;
const projectId = this.$route.query.projectId;
const productCode = this.$route.query.productCode;
const openId = window.sessionStorage.getItem("openId");
this.$axios({
method: 'post',
url: url,
data: {
projectId: projectId,
openId: openId,
}
}).then((response) => {
if (response.data.code === 200) {

setTimeout(function () {
if (thiss.currentkey == '1') {
thiss.$router.push({
path: '/waitTask',
});
} else {
WeixinJSBridge.call('closeWindow');
}
}, 3000);
thiss.$vux.toast.show({text: response.data.message, time: 3000});
} else {
this.submitting = false;

thiss.$vux.toast.show({text: response.data.message, time: 3000});
}
}).catch(function (err) {
this.submitting = false;

});
},
}
}



// WEBPACK FOOTER //
// ./src/pages/FaceRecognition.vue